// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/*eslint-disable */
export const VERSION = {
    "version": "0.9.8"
};
/*eslint-enable */
